/**
 * Cart drawer: live-update Penske Gear free shipping meter when quantity changes.
 * Uses gear map from initial DOM (data-is-gear, data-line-key); fetches /cart.js after cart/change.js.
 * Cart page is unchanged (no data-drawer-meter).
 */

/* ========== Drawer header offset fix ==========
 * Sets --header-offset on :root so mobile cart drawer (top/height) positions below
 * .wrapper-header (header + announcement bar). Prevents content being cut off behind header.
 * Updates on resize, orientationchange, and ResizeObserver when header height changes.
 */
(function() {
  function updateHeaderOffset() {
    var header = document.querySelector('.wrapper-header');
    if (!header) return;
    var h = header.getBoundingClientRect().height;
    document.documentElement.style.setProperty('--header-offset', Math.ceil(h) + 'px');
  }
  function initHeaderOffset() {
    updateHeaderOffset();
    window.addEventListener('resize', updateHeaderOffset);
    window.addEventListener('orientationchange', updateHeaderOffset);
    var header = document.querySelector('.wrapper-header');
    if (header && typeof ResizeObserver !== 'undefined') {
      var ro = new ResizeObserver(updateHeaderOffset);
      ro.observe(header);
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initHeaderOffset);
  } else {
    initHeaderOffset();
  }
})();

(function() {
  var THRESHOLD_CENTS = 5000;
  var PENSKE_GEAR_LINK = '<a class="free-shipping-meter__link" href="https://shop.penskeshocks.com/collections/penske-gear">Penske Gear</a>';
  var gearMap = {};
  var updateTimer = null;

  function buildGearMap() {
    gearMap = {};
    var drawer = document.getElementById('dropdown-cart');
    if (!drawer) return;
    var items = drawer.querySelectorAll('[data-line-key], [data-item-key]');
    for (var i = 0; i < items.length; i++) {
      var key = items[i].getAttribute('data-line-key') || items[i].getAttribute('data-item-key');
      if (key) gearMap[key] = items[i].getAttribute('data-is-gear') === 'true';
    }
  }

  function updateDrawerMeter(cart) {
    var container = document.querySelector('#dropdown-cart [data-drawer-meter]');
    if (!container) return;

    if (!cart || cart.item_count === 0) {
      container.style.display = 'none';
      container.setAttribute('aria-hidden', 'true');
      return;
    }

    var cartSubtotal = cart.items_subtotal_price || 0;
    var gearSubtotal = 0;
    for (var i = 0; i < (cart.items || []).length; i++) {
      var item = cart.items[i];
      if (gearMap[item.key]) gearSubtotal += item.final_line_price || 0;
    }

    var onlyGear = gearSubtotal > 0 && gearSubtotal === cartSubtotal;
    var mixedCart = gearSubtotal > 0 && gearSubtotal < cartSubtotal;

    if (gearSubtotal <= 0 && !mixedCart) {
      container.style.display = 'none';
      container.setAttribute('aria-hidden', 'true');
      return;
    }

    container.style.display = '';
    container.removeAttribute('aria-hidden');

    var barWrap = container.querySelector('[data-meter-bar-wrap]');
    var bar = container.querySelector('[data-meter-bar]');
    var textEl = container.querySelector('[data-meter-text]');
    var infoEl = container.querySelector('[data-meter-info]');

    if (mixedCart) {
      if (barWrap) barWrap.style.display = 'none';
      if (textEl) textEl.style.display = 'none';
      if (infoEl) infoEl.style.display = '';
      return;
    }

    if (onlyGear) {
      if (barWrap) barWrap.style.display = '';
      if (infoEl) infoEl.style.display = 'none';

      var remainingCents = Math.max(0, THRESHOLD_CENTS - gearSubtotal);
      var pct = THRESHOLD_CENTS ? (gearSubtotal * 100 / THRESHOLD_CENTS) : 0;
      var percent = Math.min(100, Math.max(0, Math.round(pct)));
      var gearDollars = Math.floor(gearSubtotal / 100);

      if (barWrap) {
        barWrap.setAttribute('aria-valuenow', String(gearDollars));
        barWrap.style.display = '';
      }
      if (bar) bar.style.width = percent + '%';

      if (textEl) {
        textEl.style.display = '';
        var msg;
        if (remainingCents > 0) {
          textEl.classList.remove('free-shipping-meter__text--success');
          var formatted = typeof Shopify !== 'undefined' && Shopify.formatMoney
            ? Shopify.formatMoney(remainingCents, window.money_format || '${{amount}}')
            : '$' + (remainingCents / 100).toFixed(2);
          msg = 'Add ' + formatted + ' more to get free shipping on ' + PENSKE_GEAR_LINK + '.';
        } else {
          textEl.classList.add('free-shipping-meter__text--success');
          msg = "You've unlocked free shipping on Penske Gear!";
        }
        textEl.innerHTML = msg;
      }
    }
  }

  function fetchCartAndUpdate() {
    if (updateTimer) clearTimeout(updateTimer);
    updateTimer = setTimeout(function() {
      updateTimer = null;
      var xhr = new XMLHttpRequest();
      xhr.open('GET', '/cart.js', true);
      xhr.onload = function() {
        if (xhr.status === 200) {
          try {
            var cart = JSON.parse(xhr.responseText);
            updateDrawerMeter(cart);
          } catch (e) {}
        }
      };
      xhr.send();
    }, 150);
  }

  function onCartChange() {
    fetchCartAndUpdate();
  }

  function init() {
    buildGearMap();

    if (typeof jQuery !== 'undefined') {
      jQuery(document).ajaxComplete(function(event, xhr, settings) {
        if (settings.url && (settings.url.indexOf('/cart/change.js') !== -1)) onCartChange();
      });
    }

    var drawerTotal = document.querySelector('#dropdown-cart .summary .price');
    if (drawerTotal && typeof MutationObserver !== 'undefined') {
      var observer = new MutationObserver(function() { onCartChange(); });
      observer.observe(drawerTotal, { childList: true, characterData: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
